// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionsPage_container__8Jtiu","left-column":"SubscriptionsPage_left-column__eggGG"};